import React from 'react';

function AttachmentFiles() {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11">
      <path d="M6.87 9.49l3.426-3.424c2.808-2.808-1.32-6.937-4.13-4.128L1.72 6.386c-2.062 2.06.755 4.877 2.816 2.816L9.02 4.79c1.1-1.1-.475-2.676-1.576-1.576l-3.38 3.38" stroke="currentColor" fill="none" />
    </svg>
  );
}

export default AttachmentFiles;
